import type { App, Directive, DirectiveBinding } from 'vue'
import { useI18n } from '@/hooks/web/useI18n'
import router from '@/router'
import {getMenuButton} from '@/api/sys/role'


const { t } = useI18n()

let menuButtonPermission: string[] = [];
const hasPermission = (value: string): boolean => {
  if(!value){
    throw new Error(t('permission.hasPermission'))
  }
  return menuButtonPermission.includes(value)
}
function hasPermi(el: Element, binding: DirectiveBinding) {
  const value = binding.value

  const flag = hasPermission(value)
  if (!flag) {
    el.parentNode?.removeChild(el)
  }
}
const mounted = async (el: Element, binding: DirectiveBinding<any>) => {
let query = {
  menuId:router.currentRoute.value.meta.menuId||""
}
let result  = await getMenuButton(query);

menuButtonPermission =  result.data.map((item)=>{
      return item.permissionTag
})
  hasPermi(el, binding)
}

const permiDirective: Directive = {
  mounted
}

export const setupPermissionDirective = (app: App<Element>) => {
  app.directive('hasPermi', permiDirective)
}

export default permiDirective
